/** Canned assistant answers powering the drawer while mocks are on. */
export const DEMO_ASSISTANT_QA: Array<{ question: string; answer: string }> = [
  {
    question: '¿Cómo vamos?',
    answer:
      'En general bien: 3 de 4 proyectos activos están en curso normal. Montaje Eléctrico Subestación Sur requiere atención por bloqueos de materiales.',
  },
  {
    question: '¿Qué está atrasado?',
    answer:
      'Hay 1 actividad atrasada: Validación planos eléctricos, a cargo de Daniela Rojas, sin actualización hace 3 días.',
  },
  {
    question: '¿Qué debo revisar hoy?',
    answer:
      'Te recomiendo revisar el bloqueo de Instalación tablero eléctrico y la decisión pendiente sobre el proveedor de sensores.',
  },
  {
    question: '¿Qué actividades no tienen actualización?',
    answer:
      'Capacitación operadores (8 días) y Validación planos eléctricos (3 días) no registran actualizaciones recientes.',
  },
];

export const DEMO_ASSISTANT_GREETING =
  'Hola Renata, soy KainOS AI. Puedo responder preguntas sobre el estado real de tus proyectos.';

export const DEMO_ASSISTANT_FALLBACK =
  'Estoy revisando la información del proyecto para responder eso con precisión.';
